<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">
          Patient Vitals for Patient ::
          <span class="text-uppercase" style="color: black">{{
            visit_data.patient_id + " - " + visit_data.name
          }}</span>
        </h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div style="background-color: bisque" class="form-group col-md-12">
            <button
              v-on:click="shiftVitals('form')"
              :style="{
                color: 'blue',
                backgroundColor: vitalsMode == 'form' ? '#d4aec9' : 'bisque',
                borderRadius: '5px',
                borderColor: 'bisque',
                boxShadow: 'none',
                outline: 'none',
              }"
            >
              Input Vitals</button
            >.
            <button
              v-on:click="shiftVitals('data')"
              :style="{
                color: 'blue',
                backgroundColor: vitalsMode == 'data' ? '#d4aec9' : 'bisque',
                borderRadius: '5px',
                borderColor: 'bisque',
                boxShadow: 'none',
                outline: 'none',
              }"
            >
              Show Uptake
            </button>
          </div>
        </div>
        <form v-if="!loading && vitalsMode == 'form'">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="temperature">Temperature (&deg;C)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                name="temperature"
                @change="change_input"
                class="form-control"
                :value="temperature"
                placeholder="Temperature"
              />
            </div>
            <div class="form-group col-md-4">
              <label for="heartRate">Heart Rate (bpm)</label>
              <input
                type="number"
                name="heartRate"
                @change="change_input"
                class="form-control"
                :value="heartRate"
                placeholder="Heart Rate"
              />
            </div>
            <div class="form-group col-md-4">
              <label for="bloodPressure">Blood Pressure (mmHg)</label>
              <input
                type="text"
                name="bloodPressure"
                @change="change_input"
                class="form-control"
                :value="bloodPressure"
                placeholder="Systolic/Diastolic"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-3">
              <label for="respiratoryRate"
                >Respiratory Rate (breaths/min)</label
              >
              <input
                type="number"
                name="respiratoryRate"
                @change="change_input"
                class="form-control"
                :value="respiratoryRate"
                placeholder="Respiratory Rate"
              />
            </div>
            <div class="form-group col-md-3">
              <label for="oxygenSaturation">Oxygen Saturation (%)</label>
              <input
                type="number"
                step="0.1"
                min="0"
                name="oxygenSaturation"
                @change="change_input"
                class="form-control"
                :value="oxygenSaturation"
                placeholder="Oxygen Saturation"
              />
            </div>
            <div class="form-group col-md-3">
              <label for="oxygenSaturation">Weight (Kg)</label>
              <input
                type="number"
                name="weight"
                step="0.01"
                min="0"
                @change="change_input"
                class="form-control"
                :value="weight"
                placeholder="Weight in Kilograms"
              />
            </div>
            <div class="form-group col-md-3">
              <label for="oxygenSaturation">Height (cm)</label>
              <input
                type="number"
                name="height"
                step="0.01"
                min="0"
                @change="change_input"
                class="form-control"
                :value="height"
                placeholder="Height in Centimeters"
              />
            </div>
            <!-- <div class="form-group col-md-4">
              <label for="notes">Notes</label>
              <textarea
                name="notes"
                @change="change_input"
                class="form-control"
                :value="notes"
                placeholder="Additional Notes"
              ></textarea>
            </div> -->
          </div>
          <button @click="submitHandler" class="btn btn-primary righter">
            Submit
          </button>
        </form>

        <div class="row" style="color: black" v-if="vitalsMode == 'data'">
          <div class="col-sm-12">
            <MsterGraphCanvas
              :myChartData="myChartData"
              :chartTitle="chartTitle"
              :chartType="chartType"
              :graphHeight="'400px'"
            />
          </div>
          <div class="col-sm-12">
            <div class="container mt-2">
              <h5 class="mb-4">Triage Vitals</h5>
              <div class="table-container">
                <table class="table table-striped table-bordered">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Temperature (°C)</th>
                      <th scope="col">Heart Rate (bpm)</th>
                      <th scope="col">Blood Pressure (mmHg)</th>
                      <th scope="col">Respiratory Rate (breaths/min)</th>
                      <th scope="col">Oxygen Saturation (%)</th>
                      <th scope="col">Weight (Kg)</th>
                      <th scope="col">Height (cm)</th>
                      <th scope="col">Time Recorded</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="record in rawv_data" :key="record.id">
                      <td>{{ record.temperature }}</td>
                      <td>{{ record.heart_rate }}</td>
                      <td>{{ record.blood_pressure }}</td>
                      <td>{{ record.respiratory_rate }}</td>
                      <td>{{ record.oxygen_saturation }}</td>
                      <td>{{ record.weight }}</td>
                      <td>{{ record.height }}</td>
                      <td>{{ convertTime(record.created_at) }}</td>
                    </tr>

                    <!-- Add more rows as needed -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div style="color: black" v-if="vitalsMode == 'data'"></div>
        <div class="loader-style" v-if="loading">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import MsterGraphCanvas from "../../Patients/components/master_graph_canvas.vue";
import FormatDateTime from "../../../timezone/utc_local_time";

export default {
  name: "VitalsModal",
  data() {
    return {
      loading: true,
      visit_data: {},
      patient_id: "",
      temperature: "",
      weight: "",
      height: "",
      heartRate: "",
      bloodPressure: "",
      respiratoryRate: "",
      oxygenSaturation: "",
      notes: "",
      vitalsMode: "form", //"form data",

      rawv_data: [],
      chartTitle: "",
      chartType: "",
      myChartData: {},

      //
      // graphHeight: "400px",
      // chartTitle: "Graph Title",
      // chartType: "line",
      // myChartData: {
      //   labels: [
      //     "January",
      //     "February",
      //     "March",
      //     "April",
      //     "May",
      //     "june",
      //     "july",
      //     "August",
      //     "September",
      //     "October",
      //     "November",
      //     "December",
      //   ],

      //   datasets: [
      //     {
      //       type: "line", // radar, line, bar, polarArea
      //       label: "Sample Data",
      //       backgroundColor: "rgba(65, 190, 12, 0.7)",
      //       borderColor: "rgba(75, 192, 192, 1)",
      //       data: [65, 59, 80, 81, 56, 65, 59, 80, 81, 56, 77, 80],
      //       // fill: true, // for area graph
      //       // tension: 0.2, //for curve
      //       // pointRadius: 4, // Size of the dots
      //       // pointBackgroundColor: "rgba(255, 0, 192, 1)", // Color of the dots
      //       // pointStyle: "circle", // Shape of the dots (circle, triangle, rect, etc.)
      //     },
      //   ],
      // },
    };
  },

  //   components reserved
  components: {
    MsterGraphCanvas,
  },

  // components reserved
  props: {
    visit_id: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    closeModal() {
      console.log("we are getting here");

      this.$emit("close");
    },
    convertTime(payload) {
      return FormatDateTime(payload);
    },
    async submitHandler(event) {
      event.preventDefault();
      this.loading = true;
      // const url = "record_vitals";
      const url = "triage/add_vital";

      const body = {
        patient_id: this.patient_id,
        temperature: this.temperature,
        weight: this.weight,
        height: this.height,
        heart_rate: this.heartRate,
        blood_pressure: this.bloodPressure,
        respiratory_rate: this.respiratoryRate,
        oxygen_saturation: this.oxygenSaturation,
        notes: this.notes,
        visit_id: this.visit_id,
      };

      // console.log(body);

      const resp = await generalApiRequest(url, "POST", body, 1);
      if (resp) {
        this.loading = false;
        this.closeModal();
        window.location.reload();
      }
    },
    change_input(e) {
      this[e.target.name] = e.target.value;
    },
    get_patient(option) {
      this.patient_id = option.id;
    },
    shiftVitals(mode) {
      this.vitalsMode = mode;
    },
    async call_api() {
      this.loading = true;
      const url = "getVisitById/" + this.visit_id;
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      console.log(res);
      console.log(this.visit_id);

      this.visit_data = res;
      this.loading = false;
      this.patient_id = res.patient_id;

      //   this.isLoaded = true;
    },

    async fetch_track_vitals() {
      const url = "triage/vitals_for_a_visit";
      const body = { visit_id: this.visit_id };
      const res = await generalApiRequest(url, "POST", body, 1);
      // console.log(res);
      this.myChartData = res.visual_data_set.myChartData;
      this.chartTitle = res.visual_data_set.chartTitle;
      this.chartType = res.visual_data_set.chartType;
      this.rawv_data = res.raw_data;

      //   this.isLoaded = true;
    },
  },

  mounted() {
    this.call_api();
    this.fetch_track_vitals();
  },
};
</script>

<style scoped>
.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

.loader-style {
  display: flex;
  justify-content: center;
  font-weight: bold;
  color: black;
  font-size: 2em;
}

.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
}
</style>
